import { Stack, Text, useTheme } from "@bps/fluent-ui";

import { RunResult } from "./deploy-management.utils";

type Tone = "success" | "error";

interface Props {
  title: string;
  tone: Tone;
  results: RunResult[];
}

export const ResultColumn: React.FC<Props> = ({ title, tone, results }) => {
  const theme = useTheme();
  const colour =
    tone === "success" ? theme.palette.green : theme.semanticColors.errorText;

  return (
    <Stack.Item grow={1} styles={{ root: { width: "50%" } }}>
      <Stack
        tokens={{ childrenGap: theme.spacing.s2 }}
        styles={{
          root: {
            maxHeight: 200,
            overflowY: "auto",
            padding: theme.spacing.s1,
            border: `1px solid ${theme.palette.neutralLight}`
          }
        }}
      >
        <Text
          variant="smallPlus"
          styles={{ root: { fontWeight: 600, color: colour } }}
        >
          {title} ({results.length})
        </Text>
        {results.map(result => {
          const { tenantName, detail } = result;
          return (
            <Text
              key={result.id}
              variant="small"
              styles={{ root: { color: colour } }}
            >
              {tenantName}
              {detail ? ` — ${detail}` : ""}
            </Text>
          );
        })}
      </Stack>
    </Stack.Item>
  );
};
